<template>
  <div class="main-certificate">
    <el-row>
      <my-collapse accordion class="searchForm-colleapse">
        <my-collapse-item>
          <template slot="title">
            <el-form
              :inline="true"
              :model="searchForm"
              class="demo-form-inline search-form"
              size="mini"
            >
              <el-form-item>
                <el-input
                  v-model="searchForm.certificateCode"
                  placeholder="证书编号"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchForm.realName"
                  placeholder="姓名"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  v-model="searchForm.idNumber"
                  placeholder="证件号码"
                  clearable
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="searchForm.certificateType"
                  placeholder="证书类别:"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, i) in metaData.certificateType"
                    :key="i"
                    :label="item.metaName"
                    :value="item.metaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="searchForm.certificateLevel"
                  placeholder="证书级别:"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, i) in metaData.certificateLevel"
                    :key="i"
                    :label="item.metaName"
                    :value="item.metaCode"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="onSearchUserCerPager"
                  icon="el-icon-search"
                  >查询
                </el-button>
              </el-form-item>
            </el-form>
          </template>
          <el-form
            :inline="true"
            :model="searchForm"
            class="demo-form-inline search-form"
            size="mini"
          >
            <el-form-item>
              <el-select
                v-model="searchForm.agentId"
                placeholder="所属合作单位:"
                clearable
                :loading="loadingAgent"
                remote
                :remote-method="onGetAgentList"
                filterable
              >
                <el-option
                  v-for="(item, i) in agentList"
                  :key="i + '-agentId'"
                  :label="item.agentName"
                  :value="item.agentId"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="证书发放时间:">
              <el-date-picker
                v-model="issuingDate"
                clearable
                type="daterange"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
          </el-form>
        </my-collapse-item>
      </my-collapse>
    </el-row>
    <el-row class="button">
      <el-button size="mini" @click="certificateVisible = true">
        添加证书
      </el-button>
      <el-button size="mini" @click="importUserCertificateVisible = true">
        导入证书
      </el-button>
      <el-button size="mini" @click="deleteCertificate">
        删除
      </el-button>
    </el-row>
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="tableData"
        v-loading="loading"
        row-key="id"
        stripe
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column
          align="center"
          type="selection"
          width="50"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="certificateCode"
          label="证书编号"
          show-overflow-tooltip
          width="170"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="issuingDate"
          label="发证时间"
          show-overflow-tooltip
          :formatter="formatIssuingDate"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="realName"
          label="姓名"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="idNumber"
          label="证件号码"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="certificateType"
          label="证书类别"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          align="center"
          prop="certificateLevel"
          label="证书级别"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="agentName"
          label="所属合作单位"
          show-overflow-tooltip
          width="120"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createUsername"
          label="创建人"
        ></el-table-column>
        <el-table-column
          align="center"
          prop="createDate"
          show-overflow-tooltip
          label="创建时间"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑证书"
              placement="top-start"
            >
              <el-button
                icon="el-icon-edit-outline"
                circle
                type="primary"
                size="mini"
                @click="onEditCertificate(scope.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="tableTotal"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      @current-change="onCurrentPageChange"
      align="center"
    >
    </el-pagination>

    <el-dialog
      title="发放证书"
      :visible.sync="certificateVisible"
      :before-close="initCertificateForm"
      destroy-on-close
      width="33%"
    >
      <el-form
        :model="certificateForm"
        ref="certificateForm"
        :rules="cerRules"
        label-width="100px"
      >
        <el-form-item label="证书编号:" prop="certificateCode">
          <el-input
            v-model="certificateForm.certificateCode"
            placeholder="证书编号（默认自动生成，推荐自动生成）"
          ></el-input>
        </el-form-item>
        <el-form-item label="选择人员:" prop="userId">
          <el-select
            v-model="certificateForm.userId"
            filterable
            remote
            clearable
            reserve-keyword
            placeholder="请输入用户姓名搜索"
            :remote-method="getUserList"
            :loading="loading"
          >
            <el-option
              v-for="item in userOptions"
              :key="item.userId"
              :label="item.realName"
              :value="item.userId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书类型:" prop="certificateType">
          <el-select
            v-model="certificateForm.certificateType"
            placeholder="请选择"
          >
            <el-option
              v-for="item in metaData.certificateType"
              :key="item.id"
              :label="item.metaName"
              :value="item.metaCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="
            certificateForm.certificateType &&
              certificateForm.certificateType === '1'
          "
          label="证书项目:"
          prop="project"
        >
          <el-select
            v-model="certificateForm.project"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in metaData.project"
              :key="item.id"
              :label="item.metaName"
              :value="item.metaCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="证书级别:" prop="certificateLevel">
          <el-select
            v-model="certificateForm.certificateLevel"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in metaDataThree"
              :key="item.id"
              :label="item.metaName"
              :value="item.metaCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="发放时间:" prop="issuingDate" clearable>
          <el-date-picker
            v-model="certificateForm.issuingDate"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="date"
            :editable="false"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item
          label="证书描述:"
          prop="cerDescription"
          v-if="
            certificateForm.certificateType &&
              certificateForm.certificateType === '1'
          "
        >
          <el-input
            type="textarea"
            class="cerDes"
            :autosize="{ minRows: 2, maxRows: 3 }"
            v-model="certificateForm.cerDescription"
            placeholder="证书描述"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="附加描述:"
          prop="description"
          v-if="
            certificateForm.certificateType &&
              certificateForm.certificateType === '1'
          "
        >
          <el-input
            type="textarea"
            class="cerDes"
            :autosize="{ minRows: 2, maxRows: 3 }"
            v-model="certificateForm.description"
            placeholder="附加描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传附件:" prop="certificateFile">
          <image-uploader
            ref="cerUploader"
            @uploadCallback="saveCertificate"
            v-model="certificateForm.certificateFile"
            :upload-dir="certificateForm.userId"
          />
          <!--<my-file v-if="eduForm.uploadEducationAnnex" :file-list="eduForm.uploadEducationAnnex"/>-->
        </el-form-item>
        <el-form-item align="center">
          <el-button
            type="primary"
            @click="onSaveCertificate"
            :loading="saveCertificateBth"
            >保存</el-button
          >
          <el-button @click="certificateVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog
      title="导入证书"
      :visible.sync="importUserCertificateVisible"
      width="40%"
    >
      <el-form label-width="80px">
        <el-form-item label="导入说明">
          <div style="color:red;">一次最多只能上传1000条数据</div>
        </el-form-item>
        <el-form-item label="证书类型">
          <el-select v-model="importCertificateType" placeholder="请选择">
            <el-option
              v-for="item in metaData.certificateType"
              :key="item.id"
              :label="item.metaName"
              :value="item.metaCode"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="text"
            @click="downloadTemplate(importCertificateType)"
          >
            下载导入模板</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-upload
            :disabled="!importCertificateType"
            ref="fileUploader"
            class="avatar-uploader"
            :action="
              apiConfig.userCertificate.api.importUserCertificate.url.import +
                '?certificateType=' +
                importCertificateType
            "
            :headers="headers"
            :multiple="false"
            :limit="1"
            :fileList="fileListUserCertificate"
            accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            :on-progress="handleProgressUserCertificate"
            :on-error="handleErrorUserCertificate"
            :on-success="uploadedUserCertificate"
            :before-upload="beforeAvatarUploadUserCertificate"
          >
            <el-tooltip
              slot="trigger"
              :disabled="!!importCertificateType"
              content="请选择证书类别"
              placement="left"
              effect="light"
            >
              <el-button size="mini" type="primary"> 选取文件</el-button>
            </el-tooltip>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserCerPager,
  searchUserCerPager,
  editPaperCertificateStatus,
  getPaperCertificateInfo,
  exportUserCertificate,
  exportZip,
  deleteCertificate,
  addCertificate,
  findCertificate,
  updateCertificate,
  exportUserCertificateError,
  getCertificateCode
} from "@/api/userCertificate";
import { getAllMapListMetaData, getUserList } from "@/api/userInfo";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import ImageUploader from "@/components/imageUploader";
import { getToken, getAdminId } from "@/utils/auth";
import { apiConfig } from "@/config/api";
import { getAgentByName } from "@/api/agentInfo";
import MyCollapse from "@/components/Collapse/collapse";
import MyCollapseItem from "@/components/Collapse/collapse-item";

export default {
  name: "userCerManage",
  directives: { permission },
  components: {
    ImageUploader,
    MyCollapse,
    MyCollapseItem
  },
  data() {
    return {
      apiConfig: apiConfig,
      headers: {
        Authorization: getToken(),
        Authorizator: getAdminId()
      },
      issuingDate: [],
      fileListUserCertificate: [],
      realName: null,
      searchForm: {
        realName: null,
        idNumber: null,
        certificateCode: null,
        certificateLevel: null,
        certificateType: null,
        agentId: null,
        issuingStartDate: null,
        issuingEndDate: null,
        certificateFile: null
      },
      exportInfoForm: {
        certificateCodes: []
      },
      exportZipForm: {
        certificateCodes: []
      },
      certificateForm: {
        id: null,
        userId: null,
        certificateCode: null,
        certificateType: null,
        project: null,
        certificateLevel: null,
        cerDescription: null,
        description: null
      },
      cerInfo: [],
      paperInfo: [],
      tableData: [],
      userOptions: [],
      currentPage: 1,
      tableTotal: -1,
      tablePages: 0,
      loading: false,
      agentList: [],
      importCertificateType: "1",
      tableLayout: defaultPageConfig.layout,
      pageSize: defaultPageConfig.pageSize,
      importUserCertificateVisible: false,
      showUserCerInfo: false,
      showUserPaperCer: false,
      certificateVisible: false,
      peperCerVisible: false,
      markBthLoading: false,
      unMarkBthLoading: false,
      metaData: {},
      metaDataThree: [],
      certificateCodes: [],
      certificateIds: [],
      saveCertificateBth: false,
      certificateEdit: false,
      loadingAgent: false,
      cerRules: {
        userId: [{ required: true, message: "请选择用户", trigger: "blur" }],
        certificateType: [
          { required: true, message: "请选择证书类型", trigger: "blur" }
        ],
        project: [
          { required: true, message: "请选择证书项目", trigger: "blur" }
        ],
        certificateLevel: [
          { required: true, message: "请选择证书级别", trigger: "blur" }
        ],
        issuingDate: [
          { required: true, message: "请选择发放时间", trigger: "blur" }
        ],
        cerDescription: [
          { required: true, message: "请输入证书描述", trigger: "blur" }
        ]
      },
      dbCertificateCode: null
    };
  },
  watch: {
    certificateVisible(val) {
      if (!val) {
        this.cerInfo = [];
      }
    },
    issuingDate(val) {
      if (val && val.length > 0) {
        this.searchForm.issuingStartDate = val[0] + " 00:00:00";
        this.searchForm.issuingEndDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.issuingStartDate = null;
        this.searchForm.issuingEndDate = null;
      }
    },
    peperCerVisible(val) {
      if (!val) {
        this.paperInfo = [];
      }
    },
    "certificateForm.certificateType"(val) {
      if (val !== "1") {
        this.metaDataThree = [];
        this.metaDataThree.push(
          this.metaData.certificateLevel[0],
          this.metaData.certificateLevel[1],
          this.metaData.certificateLevel[2]
        );
        this.certificateForm.project = null;
        if (val && this.certificateForm.certificateLevel) {
          this.onGetCertificateCode();
        }
      } else {
        this.metaDataThree = [];
        this.metaDataThree = this.metaData.certificateLevel;
        if (
          val &&
          this.certificateForm.project &&
          this.certificateForm.certificateLevel
        ) {
          this.onGetCertificateCode();
        }
      }
    },
    "certificateForm.project"(val) {
      if (this.certificateForm.certificateType !== "1") {
        if (
          this.certificateForm.certificateType &&
          this.certificateForm.certificateLevel
        ) {
          this.onGetCertificateCode();
        }
      } else {
        if (
          this.certificateForm.certificateType &&
          val &&
          this.certificateForm.certificateLevel
        ) {
          this.onGetCertificateCode();
        }
      }
    },
    "certificateForm.certificateLevel"(val) {
      if (this.certificateForm.certificateType !== "1") {
        if (this.certificateForm.certificateType && val) {
          this.onGetCertificateCode();
        }
      } else {
        if (
          this.certificateForm.certificateType &&
          this.certificateForm.project &&
          val
        ) {
          this.onGetCertificateCode();
        }
      }
    }
  },
  computed: {
    dialogTitle() {
      if (this.isFormEdit) {
        return "更新用户";
      } else {
        return "新增用户";
      }
    }
  },
  created() {
    this.getAllMapListMetaData();
  },
  methods: {
    onGetCertificateCode() {
      if (!this.dbCertificateCode) {
        let that = this;
        getCertificateCode({
          certificateType: that.certificateForm.certificateType,
          project: that.certificateForm.project,
          certificateLevel: that.certificateForm.certificateLevel
        }).then(res => {
          if (res && res.code === "200") {
            that.certificateForm.certificateCode = res.data;
          }
        });
      }
    },
    getAllMapListMetaData() {
      getAllMapListMetaData().then(res => {
        if (res && res.code === "200") {
          this.metaData = res.data;
          this.metaDataThree.push(
            this.metaData.certificateLevel[0],
            this.metaData.certificateLevel[1],
            this.metaData.certificateLevel[2]
          );
          this.loadUserCerPager();
        }
      });
    },
    onGetAgentList(query) {
      let that = this;
      if (query && query !== "") {
        that.loadingAgent = true;
        getAgentByName(query)
          .then(res => {
            if (res && res.code === "200") {
              that.agentList = res.data;
            }
          })
          .finally(() => {
            that.loadingAgent = false;
          });
      }
    },
    initCertificateForm() {
      this.certificateForm = {
        id: null,
        userId: null,
        certificateCode: null,
        certificateType: null,
        project: null,
        certificateLevel: null,
        issuingDate: null,
        certificateFile: null
      };
      this.dbCertificateCode = null;
      this.certificateVisible = false;
    },
    getUserList(val) {
      let that = this;
      that.loading = true;
      getUserList(val)
        .then(res => {
          if (res && res.code === "200") {
            that.userOptions = res.data;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    uploadCertificateFile() {
      if (
        this.certificateForm.certificateFile &&
        this.certificateForm.certificateFile.indexOf("data:") !== -1
      ) {
        this.$refs["cerUploader"].submit();
      } else {
        this.saveCertificate();
      }
    },
    onEditCertificate(row) {
      this.certificateVisible = true;
      this.realName = row.realName;
      this.onFindCertificateInfo(row.id);
    },
    onFindCertificateInfo(id, callback) {
      let that = this;
      that.loadingInstance = that.$loading(false);
      findCertificate(id)
        .then(res => {
          if (res && res.code === "200") {
            if (res.data) {
              that.certificateForm = Object.assign(
                that.certificateForm,
                res.data
              );
              if (res.data.certificateCode) {
                that.dbCertificateCode = res.data.certificateCode;
              }
              that.userOptions = [
                {
                  realName: that.realName,
                  userId: that.certificateForm.userId
                }
              ];
              if (callback && callback instanceof Function) {
                callback();
              }
            }
          }
        })
        .finally(() => {
          that.loadingInstance.close();
        });
    },
    onSaveCertificate() {
      this.$refs["certificateForm"].validate(valid => {
        if (valid) {
          this.uploadCertificateFile();
        } else {
          return false;
        }
      });
    },
    formatDate(d) {
      let date = new Date(d);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      return [year, month, day].map(this.formatNumber).join("-") + " 00:00:00";
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    saveCertificate() {
      let that = this;
      that.saveCertificateBth = true;
      let data = that._.cloneDeep(that.certificateForm);
      data.issuingDate = that.formatDate(data.issuingDate);
      if (!data.id) {
        addCertificate(data)
          .then(res => {
            if (res.code === "200") {
              that.$message.success("保存成功");
              that.initCertificateForm();
              that.certificateVisible = false;
            } else {
              that.$message.error("保存失败");
            }
          })
          .finally(() => {
            that.loadUserCerPager();
            that.saveCertificateBth = false;
            that.certificateVisible = false;
          });
      } else {
        updateCertificate(data)
          .then(res => {
            if (res.code === "200") {
              that.$message.success("保存成功");
              that.initCertificateForm();
              that.certificateVisible = false;
            } else {
              that.$message.error("保存失败");
            }
          })
          .finally(() => {
            that.loadUserCerPager();
            that.saveCertificateBth = false;
            that.certificateVisible = false;
          });
      }
    },
    handleSelectionChange: function(val) {
      this.exportInfoForm.certificateCodes = val.map(item => {
        return item.certificateCode;
      });
      this.exportZipForm.certificateCodes = val.map(item => {
        return item.certificateCode;
      });
      this.certificateIds = val.map(item => {
        return item.id;
      });
    },
    // 格式化入库类别
    storageTypeFormatter(row, column, cellValue) {
      if (cellValue === 1) {
        return "I类证书库";
      } else {
        return "II类证书库";
      }
    },
    formatIssuingDate(row, column, cellValue) {
      if (cellValue) {
        return cellValue.substring(0, 10);
      }
    },
    // 格式化入库状态
    storageStatusFormatter(row, column, cellValue) {
      if (cellValue) {
        if (cellValue === 1) {
          return "未入库";
        } else if (cellValue === 2) {
          return "审核中";
        } else if (cellValue === 3) {
          return "已入库";
        } else if (cellValue === 4) {
          return "已过期";
        }
      }
      return "";
    },
    paperStatusFormatter(row, column, cellValue) {
      if (cellValue) {
        if (cellValue === 1) {
          return "已购买";
        }
      }
      return "未购买";
    },
    // 初始化用户证书分页
    loadUserCerPager() {
      let that = this;
      that.tableLoading = true;
      getUserCerPager(that.searchForm, {
        page: that.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.tableData = res.data.list.map(item => {
              if (item.certificateType) {
                let certificateType = that.metaData.certificateType.find(
                  obj => {
                    return obj.metaCode === item.certificateType;
                  }
                );
                item.certificateType = certificateType.metaName;
              }
              if (item.certificateLevel) {
                let certificateLevel = that.metaData.certificateLevel.find(
                  obj => {
                    return obj.metaCode === item.certificateLevel;
                  }
                );
                item.certificateLevel = certificateLevel.metaName;
              }
              return item;
            });
            that.tablePages = Number(res.data.pages);
            that.tableTotal = Number(res.data.total);
          } else {
            that.tableData = [];
            that.tablePages = 0;
            that.tableTotal = 0;
          }
        })
        .finally(() => {
          that.tableLoading = false;
        });
    },
    // 查询用户证书分页
    onSearchUserCerPager() {
      let that = this;
      that.tableLoading = true;
      that.currentPage = 1;
      searchUserCerPager(that.searchForm, {
        page: that.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.tableData = res.data.list.map(item => {
              if (item.certificateType) {
                let certificateType = that.metaData.certificateType.find(
                  obj => {
                    return obj.metaCode === item.certificateType;
                  }
                );
                item.certificateType = certificateType.metaName;
              }
              if (item.certificateLevel) {
                let certificateLevel = that.metaData.certificateLevel.find(
                  obj => {
                    return obj.metaCode === item.certificateLevel;
                  }
                );
                item.certificateLevel = certificateLevel.metaName;
              }
              return item;
            });
            that.tablePages = Number(res.data.pages);
            that.tableTotal = Number(res.data.total);
          } else {
            that.tableData = [];
            that.tablePages = 0;
            that.tableTotal = 0;
          }
        })
        .finally(() => {
          that.tableLoading = false;
        });
    },
    // 翻页
    onCurrentPageChange(page) {
      this.currentPage = page;
      this.loadUserCerPager();
    },
    showCerInfo(row) {
      this.cerInfo.push(row);
      this.certificateVisible = true;
    },
    showPaperInfo(row) {
      this.onGetPaperInfo(row.id);
      this.peperCerVisible = true;
    },
    onGetPaperInfo(id) {
      let that = this;
      that.paperInfo = [];
      getPaperCertificateInfo(id).then(res => {
        if (res && res.code === "200") {
          that.paperInfo.push(res.data);
        }
      });
    },
    deleteCertificate() {
      let that = this;
      if (that.certificateIds && that.certificateIds.length > 0) {
        deleteCertificate(that.certificateIds)
          .then(res => {
            if (res && res.code === "200") {
              that.$message.success("删除成功");
              that.loadUserCerPager();
            }
          })
          .finally(() => {
            that.certificateIds = [];
          });
      } else {
        that.$message("未选择任何数据");
      }
    },
    mark(id, flag) {
      let that = this;
      if (flag === 1) {
        that.markBthLoading = true;
      } else {
        that.unMarkBthLoading = true;
      }
      editPaperCertificateStatus({ id: id, paperStatus: flag })
        .then(res => {
          if (res && res.code === "200") {
            that.onGetPaperInfo(id);
          }
        })
        .finally(() => {
          that.markBthLoading = false;
          that.unMarkBthLoading = false;
        });
    },
    exportInfo() {
      if (
        !this.exportInfoForm.certificateCodes ||
        this.exportInfoForm.certificateCodes.length <= 0
      ) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportInfoCall(true);
        });
      } else {
        this.exportInfoCall(false);
      }
    },
    exportInfoCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportInfoForm = this._.cloneDeep(this.exportInfoForm);
      if (flag) {
        this._.assign(exportInfoForm, searchForm);
      }
      exportUserCertificate(exportInfoForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    exportZipHandler() {
      if (
        !this.exportZipForm.certificateCodes ||
        this.exportZipForm.certificateCodes.length <= 0
      ) {
        this.$confirm(
          "您未勾选任何数据，系统将根据搜索条件进行下载, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          this.exportZipCall(true);
        });
      } else {
        this.exportZipCall(false);
      }
    },
    exportZipCall(flag) {
      const loading = this.$loading({
        lock: true,
        text: "正在下载",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      let searchForm = this._.cloneDeep(this.searchForm);
      let exportZipForm = this._.cloneDeep(this.exportZipForm);
      if (flag) {
        this._.assign(exportZipForm, searchForm);
      }
      exportZip(exportZipForm)
        .then(res => {
          if (!res) {
            this.$message.error("下载文件失败");
            return false;
          }
          const blob = new Blob([res.data], {
            type: "application/octet-stream"
          });
          const downloadElement = document.createElement("a");
          const href = window.URL.createObjectURL(blob);
          let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
          let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
          let result = patt.exec(contentDisposition);
          let filename = decodeURI(result[1]);
          downloadElement.style.display = "none";
          downloadElement.href = href;
          downloadElement.download = filename; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .finally(function() {
          loading.close();
        });
    },
    viewCer(cerInfo) {
      window.open(
        "http://pc.cvaetest.com/certificate?certificateCode=" +
          cerInfo.certificateCode
      );
    },
    downloadTemplate(flag) {
      if (flag === "1") {
        window.open("/template/导入证书模板（培训类）.xlsx");
      } else {
        window.open("/template/导入证书模板（其他类）.xlsx");
      }
    },
    beforeAvatarUploadUserCertificate(file) {
      let isExcel =
        file.type === "application/vnd.ms-excel" ||
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      let isLt30M = file.size / 1024 / 1024 < 30;

      if (!isExcel) {
        this.$message.error("只能上传excel文件!");
      }
      if (!isLt30M) {
        this.$message.error("上传excel大小不能超过 30M!");
      }
      return isExcel && isLt30M;
    },
    handleProgressUserCertificate: function() {
      this.loadingInstance = this.$loading({ lock: true, text: "正在上传..." });
    },
    handleErrorUserCertificate: function(error) {
      this.$message({
        message: error,
        type: "error"
      });
      this.loadingInstance.close();
    },
    uploadedUserCertificate: function(response) {
      if (response.code !== "200") {
        this.$confirm(response.message, "提示", {
          type: "error"
        });
        if (response.code === "9998") {
          exportUserCertificateError().then(res => {
            if (!res) {
              this.$message.error("下载文件失败");
              return false;
            }
            const blob = new Blob([res.data], {
              type: "application/octet-stream"
            });
            const downloadElement = document.createElement("a");
            const href = window.URL.createObjectURL(blob);
            let contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            let patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            let result = patt.exec(contentDisposition);
            let filename = decodeURI(result[1]);
            downloadElement.style.display = "none";
            downloadElement.href = href;
            downloadElement.download = filename; //下载后文件名
            document.body.appendChild(downloadElement);
            downloadElement.click(); //点击下载
            document.body.removeChild(downloadElement); //下载完成移除元素
            window.URL.revokeObjectURL(href); //释放掉blob对象
          });
        }
      } else {
        this.$message({
          message: "导入成功",
          type: "success"
        });
      }
      this.fileListUserCertificate = [];
      this.loadingInstance.close();
      this.importUserCertificateVisible = false;
      this.loadUserCerPager();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-certificate {
  .dashboard {
    &-container {
      margin: 30px;
    }

    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }

  .card-fix-height {
    position: relative;
    height: calc(100vh - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }

  .button {
    padding-bottom: 20px;
  }
  .el-dialog {
    .el-input,
    .el-select {
      width: 300px;
    }
  }
  .cerDes {
    width: 300px;
  }
}
</style>
<style lang="scss">
.main-certificate {
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: none;
  }
  .searchForm-colleapse {
    border: none;
    .el-collapse-item__header {
      line-height: unset;
      border: none;
      cursor: auto;
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .el-collapse-item__arrow.el-icon-arrow-right {
      cursor: pointer;
      &:before {
        content: "展开更多搜索条件";
        color: #e93c27;
        font-size: 12px;
      }
      &.is-active {
        transform: unset;
      }
    }
    .el-collapse-item__wrap {
      border: none;
    }
  }
  .el-table__fixed-right {
    height: 100% !important; //设置高优先，以覆盖内联样式
  }

  .el-table__fixed {
    height: 100% !important; //设置高优先，以覆盖内联样式
  }
}
</style>
